module.exports = __webpack_public_path__ + "img/AI0036.a70be3b.jpg";